import moment from "moment";

export function toYearAndMonth(date) {
    return moment(date).format('YYYY-MM');
}

export function toYearAndMonthAndDay(date) {
    return moment(date).format('YYYY-MM-DD');
}

export function toHoursAndMinutes(date) {
    return moment(date).format('HH:mm');
}

export function hourAndMinutesToMoment(time) {
    return moment(time, "HH:mm");
}

export function toMonth(date) {
    return moment(date).format("MM");
}

export function toYear(date) {
    return moment(date).format("YYYY");
}

export function toMonthName(date){
    return moment(date).locale("nl").format("MMMM");
}

export function toMonthNameWithYear(date) {
    return moment(date).locale("nl").format("MMMM YYYY");
}

export function toDateMonthYear(date) {
    return moment(date).format("DD/MM/YYYY");
}

export function toDayMonthYearHoursMinutesSeconds(date){
	return moment(date).format("DD/MM/YYYY HH:mm:ss");
}

export function shiftDtoEndDatePlusOneDayIfPastMidnight(shiftDto) {
	const start = shiftDto.labourPeriod.startDateTimestamp;
	const end = shiftDto.labourPeriod.endDateTimestamp;
	shiftDto.labourPeriod.endDateTimestamp = plusOneDayIfEndHourBeforeStartHour(end, start);
	return shiftDto;
}

function plusOneDayIfEndHourBeforeStartHour(end, start){
	return moment(end).isBefore(start) ? moment(end).add(1, "day").format(moment.HTML5_FMT.DATETIME_LOCAL) : end;
}